module.exports = __webpack_public_path__ + "static/img/jcICON2.0cd1e54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/data/jcICON2.png
// module id = ftAF
// module chunks = 49